module.exports = __webpack_public_path__ + "static/media/garage.310630d7.jpg";